import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PDF_EXPORT_QUERY_PARAM_EXPORT_TARGET } from 'common/constants/pdfExport';

// In export mode the WidgetDrawer relay publishes a page's notes/document
// references keyed to whichever export target is currently being captured. A
// page that owns several capture targets must only relay its widgets while its
// own main target is the active one, otherwise the notes get stamped onto the
// page's other capture targets too. Outside export mode widgets always relay.
export const useExportWidgetRelay = (target: string, isExportMode: boolean) => {
  const location = useLocation();

  const currentExportTarget = useMemo(
    () => (isExportMode ? new URLSearchParams(location.search).get(PDF_EXPORT_QUERY_PARAM_EXPORT_TARGET) : null),
    [isExportMode, location.search]
  );

  const shouldRelayExportWidgets = !isExportMode || currentExportTarget === target;

  return { currentExportTarget, shouldRelayExportWidgets };
};
